/* eslint-disable @typescript-eslint/no-unsafe-call */
import router from '@/router';
import { RouterV2Enum } from '@/router/router-names';
import { Toast } from '@hb/coffee';
import { landData } from '../landData';

export const jumpToMarketPage = (): void => {
  if (!landData.getGoDownload()) {
    Toast('渠道提现受限，请联系客服');
    return;
  }
  router.push({
    path: RouterV2Enum.marketPage,
    query: {
      type: '004',
      source: landData.getSouce(),
    },
  });
};
